import React from 'react';
import { styled } from '@mui/system';
import Typography from '@mui/material/Typography';
import highlightBrand from 'helpers/highlightBrand';
import AinLogo from 'assets/images/logo.svg?react';
import SpekaLogo from 'assets/images/logo_1.svg?react';
import VectorLogo from 'assets/images/logo_2.svg?react';
import HiTechLogo from 'assets/images/logo_3.svg?react';
import SeniorLogo from 'assets/images/logo_4.svg?react';
import { getLanguage } from 'translation';

const mediaList = [
  {
    id: 'Ain',
    logo: <AinLogo />
  },
  {
    id: 'Speka',
    logo: <SpekaLogo />
  },
  {
    id: 'Vector',
    logo: <VectorLogo />
  },
  {
    id: 'HiTech',
    logo: <HiTechLogo />
  },
  {
    id: 'Senior',
    logo: <SeniorLogo />
  }
];

const Background = styled('section')(() => ({
  backgroundColor: 'rgba(255, 255, 255, 1)',
  borderTop: '3px solid rgba(185, 248, 51, 1)',
  borderBottom: '3px solid rgba(185, 248, 51, 1)'
}));

const MediaWrapper = styled('div')(({ theme }) => ({
  padding: '48px 100px 60px',
  boxSizing: 'border-box',
  ...theme.wrapper,
  [theme.breakpoints.down('lg')]: {
    padding: '40px 50px 50px'
  },
  [theme.breakpoints.down('md')]: {
    padding: '28px 30px 30px'
  },
  [theme.breakpoints.down('sm')]: {
    padding: '24px 20px 40px'
  }
}));

const Title = styled(Typography)(({ theme }) => ({
  marginBottom: 50,
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  [theme.breakpoints.down('lg')]: {
    display: 'block'
  },
  [theme.breakpoints.down('md')]: {
    fontSize: 36,
    lineHeight: '41.4px',
    marginBottom: 30
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: 28,
    lineHeight: '36px',
    marginBottom: 20
  }
}));

const Description = styled(Typography)(({ theme }) => ({
  color: theme.palette.textPrimary.main,
  paddingLeft: 50,
  position: 'relative',
  top: 5,
  [theme.breakpoints.down('lg')]: {
    paddingLeft: 0
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: 18,
    lineHeight: '27px',
    marginTop: 25,
    position: 'static'
  }
}));

const List = styled('ul')(({ theme }) => ({
  listStyle: 'none',
  padding: 0,
  margin: 0,
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'row',
  [theme.breakpoints.down('lg')]: {
    gap: 5
  },
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    gap: 30
  }
}));

const ListItem = styled('li')(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}));

const Logo = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}));

const Media = ({ texts }) => {
  const lang = getLanguage();

  return (
    <Background>
      <MediaWrapper>
        <Title variant="h2">
          {highlightBrand(texts?.press_headline?.[lang])}
          <Description variant="body1">{texts?.press_subheadline?.[lang]}</Description>
        </Title>
        <List>
          {mediaList.map((item) => (
            <ListItem key={item.id}>
              <Logo>{item?.logo}</Logo>
            </ListItem>
          ))}
        </List>
      </MediaWrapper>
    </Background>
  );
};

export default Media;
